import "./loadingSpinner.css";

const LoadingSpinner = () => {
  return <div className="loadingSpinner">Loading ...</div>;
};

export default LoadingSpinner;
